import React, { useState } from 'react';
import { Row, Col, Card, Button, Typography, Space } from 'antd';
import { BellOutlined, SettingOutlined } from '@ant-design/icons';
import { useAuth } from '../Context';
import ConfiguracionNotificacionesModal from './ConfiguracionNotificacionesModal';

const { Title, Text, Paragraph } = Typography;

const ConfigurarNotificaciones = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const { sucursal } = useAuth();

  const abrirConfiguracion = () => {
    setModalVisible(true);
  };

  return (
    <>
      <Row gutter={[16, 16]} style={{ padding: '24px' }}>
        <Col span={24}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '32px' }}>
            <SettingOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
            Configuración de Notificaciones
          </Title>
        </Col>

        <Col xs={24} md={12} lg={8}>
          <Card 
            hoverable
            style={{ height: '100%' }}
            cover={
              <div style={{ 
                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)', 
                padding: '40px', 
                textAlign: 'center' 
              }}>
                <BellOutlined style={{ fontSize: '48px', color: 'white' }} />
              </div>
            }
            actions={[
              <Button 
                type="primary" 
                size="large"
                icon={<SettingOutlined />}
                onClick={abrirConfiguracion}
                style={{ margin: '0 16px' }}
              >
                Configurar Notificaciones
              </Button>
            ]}
          >
            <Card.Meta
              title={
                <span style={{ color: '#1890ff', fontSize: '18px' }}>
                  Notificaciones de Solicitudes
                </span>
              }
              description={
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                  <Paragraph style={{ marginBottom: '8px', color: '#666' }}>
                    Configure los correos que recibirán notificaciones automáticas 
                    cuando se registre una nueva solicitud.
                  </Paragraph>
                  
                  <div style={{ marginTop: '16px' }}>
                    <Text strong style={{ color: '#1890ff' }}>✨ Características:</Text>
                    <ul style={{ marginTop: '8px', paddingLeft: '20px', color: '#666' }}>
                      <li>Notificaciones en tiempo real</li>
                      <li>Información completa de la solicitud</li>
                      <li>Datos del cliente incluidos</li>
                      <li>Activación/desactivación por sucursal</li>
                    </ul>
                  </div>

                  <div style={{ 
                    marginTop: '16px', 
                    padding: '12px', 
                    background: '#f0f7ff', 
                    borderRadius: '6px',
                    border: '1px solid #b3d8ff'
                  }}>
                    <Text style={{ color: '#1890ff', fontSize: '13px' }}>
                      🏢 <strong>Sucursal actual:</strong> {sucursal || 'No definida'}
                    </Text>
                  </div>
                </Space>
              }
            />
          </Card>
        </Col>

        <Col xs={24} md={12} lg={16}>
          <Card title="Información sobre Notificaciones" style={{ height: '100%' }}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div>
                <Title level={4} style={{ color: '#1890ff', marginBottom: '12px' }}>
                  <BellOutlined /> ¿Cómo funcionan las notificaciones?
                </Title>
                <Paragraph>
                  Cuando un cliente crea una nueva solicitud desde el portal público, 
                  el sistema enviará automáticamente un correo electrónico a todos los 
                  administradores configurados para esa sucursal.
                </Paragraph>
              </div>

              <div>
                <Title level={4} style={{ color: '#52c41a', marginBottom: '12px' }}>
                  📧 ¿Qué información incluye el correo?
                </Title>
                <ul style={{ paddingLeft: '20px' }}>
                  <li><strong>Información de la solicitud:</strong> Folio, tipo, sucursal, fecha y origen</li>
                  <li><strong>Datos del cliente:</strong> Nombre, correo electrónico y teléfono</li>
                  <li><strong>Mensaje completo:</strong> Descripción detallada del cliente</li>
                  <li><strong>Diseño profesional:</strong> Formato HTML fácil de leer</li>
                </ul>
              </div>

              <div>
                <Title level={4} style={{ color: '#faad14', marginBottom: '12px' }}>
                  ⚙️ Configuración por sucursal
                </Title>
                <Paragraph>
                  Cada sucursal puede tener su propia configuración de correos de notificación. 
                  Esto permite que los equipos de cada ubicación reciban solo las solicitudes 
                  que les corresponden.
                </Paragraph>
              </div>

              <div style={{ 
                padding: '16px', 
                background: '#fff7e6', 
                borderRadius: '6px',
                border: '1px solid #ffd591'
              }}>
                <Text style={{ color: '#d48806' }}>
                  💡 <strong>Consejo:</strong> Agregue múltiples correos para asegurar que 
                  las solicitudes sean atendidas aunque alguien no esté disponible.
                </Text>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>

      <ConfiguracionNotificacionesModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        sucursal={sucursal}
      />
    </>
  );
};

export default ConfigurarNotificaciones;